export default __webpack_public_path__ + "static/ACCIDENTES-3c472bde8fb8fbb02aface21aec10c41.png";